import getYear from './get-year';

export { getYear };

export default getYear;
